import moment from 'moment';
const defaultState = {
	searchMonth: '',
	plants: [],
	plantCd: '',
	resultList: [],
	groups: {
		currentPage: 1,
		pageUnit: 10,
		totalSize: 0
	},
	dayCol: []
};
export default {
	...JSON.parse(JSON.stringify(defaultState))
};
export { defaultState };
